function filtersNews() {
  var selectHarbour = document.getElementById("harbours-filters");
  var selectCategory = document.getElementById("categories-filters");

  selectHarbour.addEventListener("change", function () {
    const data = {
      selectedHarbour: selectHarbour.value,
      selectedCategory: selectCategory.value,
    }
    getNews(data);
  });

  selectCategory.addEventListener("change", function () {
    const data = {
      selectedHarbour: selectHarbour.value,
      selectedCategory: selectCategory.value,
    }
    getNews(data);
  });

  const initialData = {
    selectedHarbour: '',
    selectedCategory: '',
  };
  getNews(initialData);
};

function getNews(data) {
  var ajaxurl = document.getElementById('js-news-filters').dataset.ajaxurl;
  data.action = document.getElementById('js-news-filters').dataset.action;

  fetch(ajaxurl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Cache-Control': 'no-cache',
    },
    body: new URLSearchParams(data),
  })
    .then(response => response.json())
    .then(response => {
      var blockForm = document.querySelector('.js-newsletter');
      blockForm.parentNode.removeChild(blockForm);
      var listing_news = document.querySelector('.js-listing-news');
      listing_news.innerHTML = response;

      // handle pagination
      const paginationLinks = document.querySelectorAll('.pagination a');
      paginationLinks.forEach(link => {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          const pageNumber = this.getAttribute('href').split('=')[1];
          handlePaginationClick(pageNumber, data);
        });
      });


      let totalElements = document.querySelectorAll('.actus__article').length;
      if (totalElements > 2) {
        listing_news.insertBefore(blockForm, document.querySelector('.actus__article:nth-child(3)'))
      }
      else {
        listing_news.insertBefore(blockForm, document.querySelector('.actus__articles .pagination'))
      }

      // error ajax response
      if (!response) {
        console.log('erreur', response);
        return;
      }
    });
}

function handlePaginationClick(pageNumber, data) {
  const data_pagination = {
    action: data.action,
    selectedHarbour: data.selectedHarbour,
    selectedCategory: data.selectedCategory,
    paged: pageNumber,
  };
  getNews(data_pagination);
}

filtersNews();
